import { TypingStats } from '../types';

interface StatsPanelProps {
  stats: TypingStats;
}

export function StatsPanel({ stats }: StatsPanelProps) {
  return (
    <div className="stats-panel">
      <div className="stat-card">
        <div className="stat-icon">⏱️</div>
        <div className="stat-info">
          <div className="stat-label">倒计时</div>
          <div className="stat-value">{stats.timeLeft}s</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">🚀</div>
        <div className="stat-info">
          <div className="stat-label">WPM</div>
          <div className="stat-value">{stats.wpm}</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">✅</div>
        <div className="stat-info">
          <div className="stat-label">准确率</div>
          <div className="stat-value">{stats.accuracy}%</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">❌</div>
        <div className="stat-info">
          <div className="stat-label">错误数</div>
          <div className="stat-value">{stats.errorCount}</div>
        </div>
      </div>

      <div className="stat-card">
        <div className="stat-icon">📊</div>
        <div className="stat-info">
          <div className="stat-label">进度</div>
          <div className="stat-value">{stats.progress}%</div>
        </div>
      </div>

      <div className="progress-bar">
        <div
          className="progress-fill"
          style={{ width: `${stats.progress}%` }}
        />
      </div>
    </div>
  );
}
